"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const vue_1 = require("vue");
const vue_2 = require("vue");
const _hoisted_1 = { class: "flex items-center gap-4" };
const _hoisted_2 = {
    key: 0,
    class: "text-lg inline-block align-middle"
};
const _hoisted_3 = { class: "inline-block align-middle" };
const _hoisted_4 = {
    key: 0,
    class: "block"
};
const _hoisted_5 = ["innerHTML"];
const _hoisted_6 = { key: 2 };
const _hoisted_7 = ["onClick"];
const _hoisted_8 = /*#__PURE__*/ (0, vue_2.createElementVNode)("span", null, "×", -1);
const _hoisted_9 = [
    _hoisted_8
];
const ToastPosition_1 = require("../../stores/toast/ToastPosition");
const toastStore_1 = require("../../stores/toast/toastStore");
const mobilePositon = "bottom-4 w-full px-4 md:w-auto md:px-0";
exports.default = (0, vue_1.defineComponent)({
    __name: 'Toasts',
    setup(__props) {
        const toastStore = (0, toastStore_1.useToastStore)();
        const positions = Object.values(ToastPosition_1.ToastPosition);
        const removeToast = (id) => {
            if (id === undefined) {
                return;
            }
            toastStore.removeToast(id);
        };
        const getToastPosition = (position) => {
            switch (position) {
                case ToastPosition_1.ToastPosition.BottomRight:
                    return `${mobilePositon} md:bottom-8 md:right-8`;
                case ToastPosition_1.ToastPosition.TopRight:
                    return `${mobilePositon} md:top-8 md:right-8`;
                case ToastPosition_1.ToastPosition.BottomLeft:
                    return `${mobilePositon} md:bottom-8 md:left-8`;
                case ToastPosition_1.ToastPosition.TopLeft:
                    return `${mobilePositon} md:top-8 md:left-8`;
            }
        };
        return (_ctx, _cache) => {
            return ((0, vue_2.openBlock)(true), (0, vue_2.createElementBlock)(vue_2.Fragment, null, (0, vue_2.renderList)((0, vue_2.unref)(positions), (position) => {
                return ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", {
                    key: position,
                    class: (0, vue_2.normalizeClass)(["fixed z-50 flex flex-col gap-2", [getToastPosition(position)]])
                }, [
                    ((0, vue_2.openBlock)(true), (0, vue_2.createElementBlock)(vue_2.Fragment, null, (0, vue_2.renderList)((0, vue_2.unref)(toastStore).toasts[position], (toast) => {
                        return ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)(vue_2.Fragment, {
                            key: toast.id
                        }, [
                            (toast.active)
                                ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", {
                                    key: 0,
                                    class: (0, vue_2.normalizeClass)(["text-white p-4 border-0 rounded flex flex-row flex-nowrap items-center gap-4 mb-2 justify-between shadow", {
                                            'bg-red': toast.type === 'danger',
                                            'bg-peach': toast.type === 'warning',
                                            'bg-green': toast.type === 'success',
                                            'bg-blue': toast.type === 'info',
                                        }])
                                }, [
                                    (0, vue_2.createElementVNode)("div", _hoisted_1, [
                                        (toast.showIcon)
                                            ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("span", _hoisted_2, [
                                                (0, vue_2.createElementVNode)("i", {
                                                    class: (0, vue_2.normalizeClass)(toast.icon)
                                                }, null, 2)
                                            ]))
                                            : (0, vue_2.createCommentVNode)("", true),
                                        (0, vue_2.createElementVNode)("span", _hoisted_3, [
                                            (toast.title)
                                                ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("strong", _hoisted_4, (0, vue_2.toDisplayString)(toast.title), 1))
                                                : (0, vue_2.createCommentVNode)("", true),
                                            (toast.messageHtml)
                                                ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("span", {
                                                    key: 1,
                                                    innerHTML: toast.messageHtml
                                                }, null, 8, _hoisted_5))
                                                : (toast.message)
                                                    ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("span", _hoisted_6, (0, vue_2.toDisplayString)(toast.message), 1))
                                                    : (0, vue_2.createCommentVNode)("", true)
                                        ])
                                    ]),
                                    (toast.showClose)
                                        ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("button", {
                                            key: 0,
                                            class: "bg-transparent text-2xl font-semibold leading-none outline-none focus:outline-none",
                                            onClick: ($event) => (removeToast(toast.id))
                                        }, _hoisted_9, 8, _hoisted_7))
                                        : (0, vue_2.createCommentVNode)("", true)
                                ], 2))
                                : (0, vue_2.createCommentVNode)("", true)
                        ], 64));
                    }), 128))
                ], 2));
            }), 128));
        };
    }
});
